import { PlatformChartListItemDto } from '@data/_generated-api/platform-api/models/platform-chart-list-item-dto';
import { PlatformChartType } from '@data/_generated-api/platform-api/models/platform-chart-type';
import { BootstrapColor } from '@/types/css-variables.types';
import { HdCycleKey } from '../bodygraph/hd-cycle-chart.models';
import { HD_CYCLE_ICONS } from './hd-chart-cycle-metadata';

/**
 * FA7-iconen + badgekleuren per chart-type (bare namen, gerenderd via `eIcon`).
 * Vastgelegd als beslispunt B11 in CHART_MANAGEMENT_PLAN.md.
 */
export const HD_CHART_TYPE_ICONS: Readonly<Record<PlatformChartType, string>> = {
  [PlatformChartType.Unknown]: 'circle-question',
  [PlatformChartType.Standard]: 'user',
  [PlatformChartType.JustNow]: 'stopwatch',
  [PlatformChartType.Cycle]: 'arrows-rotate',
  [PlatformChartType.Composite]: 'user-group',
  [PlatformChartType.Transit]: 'planet-ringed',
};

/**
 * Icoon van een chart in een lijst (matchlijsten): het eigen icoon van de chart,
 * anders bij een cycle chart het icoon van die cyclus, anders het charttype-icoon.
 */
export function hdChartListItemIcon(item: PlatformChartListItemDto): string {
  if (item.icon) return item.icon;
  const cycleIcon = item.cycleKey ? HD_CYCLE_ICONS[item.cycleKey as HdCycleKey] : undefined;
  if (cycleIcon) return cycleIcon;
  return HD_CHART_TYPE_ICONS[item.type ?? PlatformChartType.Unknown] ?? HD_CHART_TYPE_ICONS[PlatformChartType.Unknown];
}

export const HD_CHART_TYPE_COLORS: Readonly<Record<PlatformChartType, BootstrapColor>> = {
  [PlatformChartType.Unknown]: 'separator',
  [PlatformChartType.Standard]: 'elegant',
  [PlatformChartType.JustNow]: 'info-75',
  [PlatformChartType.Cycle]: 'success-75',
  [PlatformChartType.Composite]: 'cta',
  [PlatformChartType.Transit]: 'primary-75',
};
